import type { FC } from "react";
import React from "react";

import type { DualPriceContainerProps } from "../contract";
import { DualPriceWrapper } from "~/components/engage/DualPriceStickyBar/components/DualPriceWrapper";
import { DefaultDualPriceContainerTemplate } from "~/components/engage/DualPriceStickyBar/templates/DefaultDualPriceContainerTemplate";

export const DualPriceStickyContainer: FC<DualPriceContainerProps> = ({
  offer,
  discountedPricePerPassenger,
  nonDiscountedPricePerPassenger,
  onContinueWithFlight,
  isVisible = false,
}) => {
  return (
    <DualPriceWrapper
      offer={offer}
      discountedPricePerPassenger={discountedPricePerPassenger}
      nonDiscountedPricePerPassenger={nonDiscountedPricePerPassenger}
      isVisible={isVisible}
      onContinueWithFlight={onContinueWithFlight}
      Template={DefaultDualPriceContainerTemplate}
    />
  );
};
